<style lang="less">
@import "../../../../styles/common-table-list.less";
</style>
<template>
    <div style="margin:25px">
        <div class="wallet-top">
            <div class="wallet-top-box">
                <div class="img-boxshadw">
                    <img src="./images/wallet.png" style="height:47px;width:54px" alt='版权登记'/>
                </div>
                <div>
                    <p>钱包可用余额</p>
                    <p style="font-size:22px;line-height:30px;margin:10px 0px 15px">¥{{amount}}</p>
                    <div>
                        <!-- <button class="btn-104" style="margin-right:16px" @click="goMoney">提现到支付宝</button> -->
                        <button class="btn-104" @click="goCash">充值</button>
                    </div>
                </div>
            </div>
            <!-- <div class="wallet-top-box" style="width:303px;margin:0px 25px">
                <div class="img-boxshadw">
                    <img src="./images/hi.png" style="height:50px;width:50px" />
                </div>
                <div>
                    <p style="font-size:18px;line-height:25px;margin-bottom:20px">邀请好友得红包</p>
                    <div>
                        <button class="btn-104" style="width:124px">复制链接邀请好友</button>
                    </div>
                </div>
            </div> -->
            <div class="wallet-top-box" style="width:343px;margin-left:25px;" >
                <div class="img-boxshadw">
                    <img src="./images/redBao.png" style="height:52px;width:50px" alt='版权登记'/>
                </div>
                <div>
                    <p>红包余额</p>
                    <p style="font-size:22px;line-height:30px;margin:10px 0px 15px">¥{{redAccount}}</p>
                    <!-- <div>
                        <button class="btn-104" style="width:104px">提现到支付宝</button>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="wallet-bottom" style="position:relative">
            <Tabs active-key="key1" @on-click="changeTabs">
                <Tab-pane label="钱包消费明细" key="key1">
                    <wallet-pay ref="mychildZero"></wallet-pay>
                </Tab-pane>
<!--                <Tab-pane label="钱包提现明细" key="key2">
                    <wallet-cashOut ref="mychildOne"></wallet-cashOut>
                </Tab-pane>-->
                <Tab-pane label="红包消费明细" key="key3">
                    <wallet-redMoney ref="mychildThree" :tip="buyTip"></wallet-redMoney>
                </Tab-pane>
                <Tab-pane label="红包获得明细" key="key4">
                    <wallet-redMoney ref="mychildFour" :tip="buyTip"></wallet-redMoney>
                </Tab-pane>
            </Tabs>
        </div>
        <!-- 提现 -->
        <generalframe @fatherMethod="fatherMethod" v-show="showDialog" maintitle="提现到支付宝" ref="mychild">
            <div class="ts_content">
                <div class="ts_content_fr">
                    <p>提现金额：</p>
                    <input v-model="money" class="text-input" placeholder="请输入提现金额" type="text" />
                </div>
                <p class="red-p" v-if="showMoney">{{moneyTip}}</p>
                <div class="ts_content_fr">
                    <p>支付宝账号：</p>
                    <input v-model="zfb" class="text-input" type="text" placeholder="请输入支付宝账号" />
                </div>
                <p class="red-p" v-if="showZfb">请输入支付宝账号</p>
                <button class="btn-150" @click="submitMoney">申请提现</button>
            </div>
        </generalframe>
        <!-- 充值 -->
        <recharge @fatherModal="fatherModal" @findOne="findOne" @changeTabs="changeTabs(0)" v-show="showModal" ref="childModal"></recharge>
    </div>
</template>

<script>
import walletPay from './wallet-pay';
import walletCashOut from './wallet-cashOut';
import walletRedMoney from './wallet-redMoney';
import recharge from './recharge';
import { _findOne,_saveMoney,_getFindOne } from "@/api/wallet.js";
import Cookies from "js-cookie";
import generalframe from '../../vip/lawcomponent/generalframe.vue';
export default {
    name:'wallet',
    components:{
        walletPay,
        generalframe,
        walletCashOut,
        walletRedMoney,
        recharge
    },
    data() {
        return {
            amount:0,
            showDialog:!1,
            money:"",
            zfb:"",
            moneyTip:"请输入提现金额",
            showMoney:false,
            showZfb:false,
            redAccount:0,
            buyTip:1,
            showModal:!1
        }
    },
    methods: {
        //钱包可用余额
        findOne(){
            let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            _findOne({registerId:userInfo && userInfo.id?userInfo.id:'',}).then(res => {
                if(res.code==200){
                    this.amount= res.result.amount
                }
            });
        },
        //红包余额
        getFindOne(){
            let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            _getFindOne({registerId:userInfo && userInfo.id?userInfo.id:'',}).then(res => {
                if(res.code==200){
                    this.redAccount= res.result.amount
                }
            });
        },
        goMoney(){
            this.showDialog = !0;
            // this.money="";
            // this.zfb="";
            this.showMoney=false;
            this.showZfb=false;
        },
        fatherMethod() {
            this.showDialog = !1;
            this.money="";
            this.zfb="";
            this.showMoney=false;
            this.showZfb=false;
        },
        //充值
        goCash(){
            let _this = this;
            _this.showModal = !0;
            _this.$refs.childModal.showMoney = false;
        },
        fatherModal() {
            let _this = this;
            _this.showModal = !1;
        },
        //提现
        submitMoney(){
            if((10<=Number(this.money)<=Number(this.amount) && this.zfb) && !(this.showMoney || this.showZfb)){
                this.showMoney=false;
                this.showZfb = false;
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                const data={
                    registerId:userInfo && userInfo.id?userInfo.id:'',
                    drawWay:"alipay",
                    drawAccount: this.zfb,
                    drawAmount:this.money,
                    drawOrigin:'ewallet'
                }
                _saveMoney(data).then(res => {
                    if(res.code==200){
                       this.showDialog = !1;
                       toast("提交申请成功")
                       this.money="";
                       this.zfb="";
                       this.findOne();
                       this.changeTabs(1);
                    }else{
                        toast(res.message)
                    }
                });
            }else{
               this.showMoney= this.showMoney || !this.money
                this.showZfb = this.showZfb || ! this.zfb
            }
        },
        changeTabs(val){
            /*if(val==0){
                this.$refs.mychildZero.findRecordByPage();
            }else if(val==1){
                this.$refs.mychildOne.findByPage();
            }else if(val==2){
                this.buyTip=1;
                this.$refs.mychildThree.findByPage();
            }else if(val==3){
                this.buyTip=2;
                this.$refs.mychildFour.findByPage();
            }*/

          if(val==0){
            this.$refs.mychildZero.findRecordByPage();
          }else if(val==1){
            this.buyTip=1;
            this.$refs.mychildThree.findByPage();
          }else if(val==2){
            this.buyTip=2;
            this.$refs.mychildFour.findByPage();
          }
        }
    },
    mounted() {
        this.findOne();
        this.getFindOne();
    },
    watch: {
    'money':{
      handler:function(){
        let re = /^[0-9]*$/;
        if (re.test(this.money)){
            if (Number(this.money) <= Number(this.amount)) {
                if (Number(this.money) < 10) {
                    this.moneyTip="提现金额不得低于10元"
                    this.showMoney = true;
                } else {
                    this.moneyTip=""
                    this.showMoney = false;
                }
            } else {
                this.moneyTip="当前可提现余额不足"
                this.showMoney = true;
            }
        }else{
            this.moneyTip="请输入正整数金额"
            this.showMoney = true;
        }
      }
    },
    'zfb':{
      handler:function(){
        if(this.zfb){
           this.showZfb = false
        }else{
           this.showZfb = true
        }
      }
    }
  },
}
</script>
<style scoped lang="less">
.wallet-top{
    width:1108px;
    height: 155px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom:25px;
    .wallet-top-box{
        width:412px;
        height:155px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
        border-radius:8px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .img-boxshadw{
            width:124px;
            height:155px;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
            border-radius:8px 0px 0px 8px;
            margin-right: 29px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        p{
            font-size:14px;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:20px;
        }
        .btn-104{
            width:104px;
            height:29px;
            line-height: 29px;
            border:0;
            outline: none;
            background:rgba(255,216,0,1);
            border-radius:4px;
            cursor: pointer;
            font-size:12px;
            font-weight:400;
            color:rgba(78,78,78,1);
        }
    }
}
.wallet-bottom{
    width:1108px;
    height:726px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
    border-radius:8px;
     /deep/ .ivu-tabs-bar{
        margin-bottom:0px;
        border-bottom:0px;
        margin-left: 25px;
    }
    /deep/ .ivu-tabs-nav .ivu-tabs-tab{

        padding:20px 0px;
        color:rgba(153,153,153,1);
        width: 108px!important;
    }
    /deep/ .ivu-tabs-nav .ivu-tabs-tab-active{
        color:rgba(51,51,51,1);
    }
    /deep/ .ivu-tabs-ink-bar{
        background-color: #333333;
         width: 84px!important;
    }
}
.ts_content{
    overflow: hidden;
    height: 246px;
    position: relative;
    .ts_content_fr{
        display:flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 30px;
        p{
            width:85px;
            text-align:left;
            margin-right:10px;
            margin-left: 30px;
            color:rgba(50,50,50,1);
        }
        .text-input{
            width:252px;
            height:46px;
            outline: none;
            border-radius:4px;
            border:1px solid rgba(222,226,230,1);
            text-indent: 10px;
            color:rgba(50,50,50,1);
        }
    }
    .btn-150{
        width:150px;
        height:37px;
        outline: none;
        border:0px;
        background:rgba(255,216,0,1);
        border-radius:21px;
        font-size:14px;
        font-weight:600;
        color:rgba(78,78,78,1);
        cursor: pointer;
        position: absolute;
        bottom:0px;
        left:135px;
    }
    .red-p{
        color: #f00;
        text-align: left;
        margin-left: 125px;
    }
}
</style>
